import { NotifyHelper } from "../../../helpers/toast";
import { eNhomCauHoiActionsObj } from "../../action-types/cau-hoi/INhomCauHoiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const nhomCauHoiActions = {
  ...generateActions(eNhomCauHoiActionsObj, "NHOM_CAU_HOI"),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "IMPORT_SUCCESS",
    () => {
      NotifyHelper.Success("Import thành công!");
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "IMPORT_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "SAVE_MUCTRINANG_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "SAVE_MUCTRINANG_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "PROGRESS_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eNhomCauHoiActionsObj,
    "NHOM_CAU_HOI",
    "PROGRESS_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
